import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { IPrimaryKey } from "~app/common/services/cqs/IPrimaryKey";
import { VKKontraktUtskriftDTO } from "../../models/utskrift/utskrift-models";
import { IKontraktSigneringLeverantor, IKontraktSigneringRequestDTO } from "../../models/utskrift/utskriftSignering-models";

export class CreateAndSendContractCommand extends BasicCommand<CreateAndSendContractCommand> {
    readonly kontraktId: number;
    readonly primaryDokumentTyp: string;
    readonly giltigAntalDagar?: number;
    readonly utvaldaUtskrifter: VKKontraktUtskriftDTO[];
    readonly utvaldaLeverantorer: IKontraktSigneringLeverantor[];

    static readonly $type = "CreateAndSendContractCommand";

    static readonly $groupKey = "KontraktUtskrift";

    get primaryKey(): IPrimaryKey<CreateAndSendContractCommand> {
        return {
            kontraktId: this.kontraktId
        };
    }

    constructor(kontraktId: number, signering: IKontraktSigneringRequestDTO) {
        super(CreateAndSendContractCommand.$type, CreateAndSendContractCommand.$groupKey, CommandType.Replace);
        this.kontraktId = kontraktId;
        this.utvaldaUtskrifter = signering.utvaldaUtskrifter;
        this.utvaldaLeverantorer = signering.utvaldaLeverantorer;
        this.primaryDokumentTyp = signering.primaryDokumentTyp;
        this.giltigAntalDagar = signering.giltigAntalDagar;
    }
}
